module.exports = __webpack_public_path__ + "static/media/table-rows.382ac1fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/table-rows.svg
// module id = ./src/assets/icons/table-rows.svg
// module chunks = 0